export default "__VITE_ASSET__D4YLbAX7__"